/**
 * The little the route table needs to know about the Mad Monkey page: which route ids and hostel slugs exist, and
 * what to call them in a page head. Kept apart from `content.ts` on purpose: `marketingRoutes.tsx` is part of the
 * entry every marketing page loads, and the page's content (all 23 hostels and their places) is not.
 * `routeIndex.test.ts` checks this against `content.ts`, so the two cannot drift.
 */

export interface RouteIndexEntry {
	id: string;
	name: string;
	blurb: string;
	/** the slug of its first stop, whose photo represents the route */
	first: string;
}

export interface HostelIndexEntry {
	slug: string;
	name: string;
}

export const ROUTE_INDEX: RouteIndexEntry[] = [
	{
		id: "banana-pancake",
		name: "The Banana Pancake Trail",
		blurb:
			"The classic Southeast Asia loop, hostel to hostel. Northern Thailand, the slow boat into Laos, Vietnam top to middle, then Cambodia's temples and islands.",
		first: "bangkok",
	},
	{
		id: "cambodia-loop",
		name: "Cambodia, temples to islands",
		blurb: "Angkor at sunrise, the capital's rooftops, Kampot's river (new from 1 November), then two very different islands to finish.",
		first: "siem-reap",
	},
	{
		id: "thailand-north-south",
		name: "Thailand, mountains to beach",
		blurb: "Khao San nights, northern temples and mountains, slow days in Pai, then the beach in Phuket.",
		first: "bangkok",
	},
	{
		id: "bali-lombok",
		name: "Bali, Gili T and Lombok",
		blurb: "Cliffs and surf in Uluwatu, manta rays off Lembongan, the car-free Gilis, then quiet Kuta Lombok.",
		first: "uluwatu",
	},
	{
		id: "philippines-islands",
		name: "Philippine island hop",
		blurb: "Land in Manila, run to Palawan's emptiest beach, then hop the Visayas from Bohol to Siquijor and finish surfing in Siargao.",
		first: "manila",
	},
];

export const HOSTEL_INDEX: HostelIndexEntry[] = [
	{ slug: "bangkok", name: "Bangkok" },
	{ slug: "chiang-mai", name: "Chiang Mai" },
	{ slug: "pai", name: "Pai" },
	{ slug: "phuket", name: "Phuket" },
	{ slug: "hanoi", name: "Hanoi" },
	{ slug: "hoi-an", name: "Hoi An" },
	{ slug: "siem-reap", name: "Siem Reap" },
	{ slug: "phnom-penh", name: "Phnom Penh" },
	{ slug: "kampot", name: "Kampot" },
	{ slug: "koh-rong", name: "Koh Rong" },
	{ slug: "koh-sdach", name: "Koh Sdach" },
	{ slug: "luang-prabang", name: "Luang Prabang" },
	{ slug: "vang-vieng", name: "Vang Vieng" },
	{ slug: "manila", name: "Manila" },
	{ slug: "nacpan-beach", name: "Nacpan Beach" },
	{ slug: "panglao", name: "Panglao" },
	{ slug: "siquijor", name: "Siquijor" },
	{ slug: "dumaguete", name: "Dumaguete" },
	{ slug: "siargao", name: "Siargao" },
	{ slug: "gili-trawangan", name: "Gili Trawangan" },
	{ slug: "kuta-lombok", name: "Kuta Lombok" },
	{ slug: "nusa-lembongan", name: "Nusa Lembongan" },
	{ slug: "uluwatu", name: "Uluwatu" },
];

/** The hostels that have a map page of their own, `/p/mad-monkey-<slug>` (`mapHostels` in madMonkeyData.json): those with a synced list. */
export const MAP_HOSTEL_SLUGS: string[] = [
	"bangkok",
	"chiang-mai",
	"pai",
	"phuket",
	"hanoi",
	"hoi-an",
	"siem-reap",
	"phnom-penh",
	"kampot",
	"koh-rong",
	"koh-sdach",
	"luang-prabang",
	"vang-vieng",
	"manila",
	"nacpan-beach",
	"panglao",
	"siquijor",
	"dumaguete",
	"siargao",
	"gili-trawangan",
	"kuta-lombok",
	"nusa-lembongan",
	"uluwatu",
];
